<template>
  <v-container>
    <div class="text-right">
      <v-btn dark fab small class="float-left" v-if="isOwner">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn fab small class="mr-4" :disabled="isOwner">
        <v-icon>mdi-message</v-icon>
      </v-btn>
      <v-btn fab small class="mr-4" :disabled="isOwner">
        <v-icon>mdi-bookmark-outline</v-icon>
      </v-btn>
      <v-btn fab small class="mr-4" :disabled="isOwner">
        <v-icon>mdi-alert</v-icon>
      </v-btn>
      <v-btn fab small>
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </div>
    <h2 class="mt-6">Alex Exarhos</h2>
    <div class="overline">US / WA / Seattle / Beacon Hill</div>
    <div class="mt-6 d-flex">
      <v-btn text class="flex-grow-1">Posts</v-btn>
      <v-btn text class="flex-grow-1">Favorites</v-btn>
      <v-btn text class="flex-grow-1">Shows</v-btn>
    </div>
    <div class="mt-6">
      I like folk and jazz and everything in between. And lots of other stuff too. I mostly play the guitar, but I like to tinker around on anything. I'm not in a band, but I'm always interested in jamming with people!
    </div>
    <h4 class="mt-6">Following (0)</h4>
  </v-container>
</template>

<style scoped>
</style>

<script>
export default {
  name: 'profile',
  components: {
  },
  data() {
    return {
      isOwner: true
    };
  }
}
</script>
